import { defineStore } from 'pinia'
import { computed, onBeforeMount, ref } from 'vue'
import useUserOrigin from '@/micro/composables/user/useUserOrigin'
import { OnboardingType, OriginKeyword } from '@/micro/types/register.type'
import { modifyRegisterErrorMessage } from '@/micro/utils/apiErrors'

export const useRegisterStore = defineStore('register', () => {
  const { getOriginKeyword, getOnboardingType } = useUserOrigin()

  const loadingRef = ref<boolean>(false)
  const googleLoadingRef = ref<boolean>(false)
  const error = ref<string | null>(null)

  const originKeyword = ref<OriginKeyword>('alegra-api')
  const onboardingType = ref<OnboardingType>('generic')
  const emailRef = ref<string>('')
  const passwordRef = ref<string>('')
  const couponRef = ref<string>('')
  const passCriteriaRef = ref<boolean>(false)

  const isLoading = computed(() => loading.value || googleLoading.value)

  const loading = computed({
    get: () => loadingRef.value,
    set: (value: boolean) => (loadingRef.value = value),
  })

  const googleLoading = computed({
    get: () => googleLoadingRef.value,
    set: (value: boolean) => (googleLoadingRef.value = value),
  })

  const email = computed({
    get: () => emailRef.value,
    set: (value: string) => (emailRef.value = value),
  })

  const password = computed({
    get: () => passwordRef.value,
    set: (value: string) => (passwordRef.value = value),
  })

  const coupon = computed({
    get: () => couponRef.value,
    set: (value: string) => (couponRef.value = value),
  })

  const passCriteria = computed({
    get: () => passCriteriaRef.value,
    set: (value: boolean) => (passCriteriaRef.value = value),
  })

  const setError = (message?: string, code?: number) => {
    const defaultErrorMessage =
      'Estamos experimentando fallas técnicas ahora mismo. Intenta de nuevo en un momento'

    if (!message) {
      error.value = defaultErrorMessage
      return
    }

    if (code) {
      error.value = modifyRegisterErrorMessage(message, code) ?? defaultErrorMessage
      return
    }

    error.value = message
  }

  const clearErrors = () => (error.value = null)

  onBeforeMount(() => {
    // Obtener el origen de la aplicación y el tipo de onboarding
    originKeyword.value = getOriginKeyword()
    onboardingType.value = getOnboardingType()
  })

  return {
    loading,
    googleLoading,
    isLoading,
    error,
    originKeyword,
    onboardingType,
    email,
    password,
    coupon,
    passCriteria,
    setError,
    clearErrors,
  }
})
